/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("fileserver.file_explorer", require("./rawicons/file_explorer.icon.svg.js"));
IconRegistry.registerIcon("fileserver.file", require("./rawicons/file.icon.svg.js"));
IconRegistry.registerIcon("fileserver.add_file", require("./rawicons/add_file.icon.svg.js"));
IconRegistry.registerIcon("fileserver.edit_file", require("./rawicons/edit_file.icon.svg.js"));
IconRegistry.registerIcon("fileserver.folder", require("./rawicons/folder.icon.svg.js"));
IconRegistry.registerIcon("fileserver.add_folder", require("./rawicons/add_folder.icon.svg.js"));
IconRegistry.registerIcon("fileserver.rename_folder", require("./rawicons/rename_folder.icon.svg.js"));
IconRegistry.registerIcon("fileserver.folder_open", require("./rawicons/folder_open.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_default", require("./rawicons/image_type_default.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_asdm", require("./rawicons/image_type_asdm.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_os", require("./rawicons/image_type_os.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_nxos", require("./rawicons/image_type_nxos.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_rommon", require("./rawicons/image_type_rommon.icon.svg.js"));
IconRegistry.registerIcon("fileserver.image_type_cpld", require("./rawicons/image_type_cpld.icon.svg.js"));
